// extracted by mini-css-extract-plugin
export var childrenContainer = "_14-0";
export var virtualScrollArea = "_14-1";